import PATH from '@/config/paths/PATH';
import {
  BarChartOutlined,
  BgColorsOutlined,
  CodeSandboxOutlined,
  CompassOutlined,
  KeyOutlined,
  MailOutlined,
  ProductOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  SolutionOutlined,
  StopOutlined,
  UserOutlined,
} from '@ant-design/icons';

export const MENU_CONFIG = [
  {
    key: 'report',
    icon: <BarChartOutlined />,
    label: 'Report',
    permission: 'REPORT',
    children: [
      {
        key: 'revenue',
        label: 'Revenue',
        path: PATH.REPORT.REVENUE,
      },
      {
        key: 'register',
        label: 'Register',
        path: PATH.REPORT.REGISTER,
      },
      {
        key: 'piece-stats',
        label: 'Piece Statistics',
        path: PATH.REPORT.PIECE_STATS,
      },
      {
        key: 'login-stats',
        label: 'Login Statistics',
        path: PATH.REPORT.LOGIN_STATS,
      },
      {
        key: 'game-stats',
        label: 'Game Statistics',
        path: PATH.REPORT.GAME_STATS,
      },
      {
        key: '7-day-login',
        label: '7 Day Login',
        path: PATH.REPORT.LOGIN_STREAK,
      },
      {
        key: 'open-box',
        label: 'Open Box',
        path: PATH.REPORT.OPEN_BOX,
      }
    ],
  },
  {
    key: 'prize-management',
    icon: <ProductOutlined />,
    label: 'Prize Management',
    path: PATH.PRIZE_MANAGEMENT.ROOT,
    permission: 'PRIZE_MANAGEMENT',
  },
  {
    key: 'box-management',
    icon: <CodeSandboxOutlined />,
    label: 'Box Management',
    path: PATH.BOX_MANAGEMENT,
  },
  {
    key: 'user-key-management',
    icon: <KeyOutlined />,
    label: 'User Key Management',
    path: PATH.USER_KEY_MANAGEMENT.ROOT,
    permission: 'USER_KEY_MANAGEMENT',
  },
  {
    key: 'customer-care',
    icon: <UserOutlined />,
    label: 'Customer Care',
    permission: 'CUSTOMER_CARE',
    children: [
      {
        key: 'charge-history',
        label: 'Charge History',
        path: PATH.CUSTOMER_CARE.CHARGE_HISTORY,
      },
      {
        key: 'register-cancel-history',
        label: 'Register/Cancel History',
        path: PATH.CUSTOMER_CARE.REGISTER_CANCEL_HISTORY,
      },
      {
        key: 'free-play',
        label: 'Free Play History',
        path: PATH.CUSTOMER_CARE.FREE_PLAY,
      },
      {
        key: 'solo-mode-play-history',
        label: 'Solo Mode Play History',
        path: PATH.CUSTOMER_CARE.SOLO_MODE_PLAY_HISTTORY,
      },
      {
        key: 'prize-stats',
        label: 'Prize Statistics',
        path: PATH.CUSTOMER_CARE.PRIZE_STATS,
      },
      // {
      //   key: 'multiplayer-mode-play-history',
      //   label: 'Multiplayer Mode Play History',
      //   path: PATH.CUSTOMER_CARE.MULTIPLAYER_MODE_PLAY_HISTORY,
      // },
    ],
  },
  {
    key: 'missions',
    icon: <ProfileOutlined />,
    label: 'Missions',
    path: PATH.MISSIONS.ROOT,
    permission: 'MISSIONS',
  },
  {
    key: 'topics',
    icon: <QuestionCircleOutlined />,
    label: 'Topics',
    path: PATH.TOPIC.ROOT,
    permission: 'TOPICS',
  },
  {
    key: 'topic-answers',
    icon: <SolutionOutlined />,
    label: 'Topic Answers',
    path: PATH.TOPIC_ANSWER.ROOT,
    permission: 'TOPIC_ANSWERS',
  },
  {
    key: 'wheel',
    icon: <CompassOutlined />,
    label: 'Wheel',
    path: PATH.WHEEL.ROOT,
    permission: 'WHEEL',
  },
  {
    key: 'msisdn-block',
    icon: <StopOutlined />,
    label: 'MSISDN Block',
    path: PATH.MSISDN_BLOCK.ROOT,
    permission: 'MSISDN_BLOCK',
  },
  {
    key: 'send-sms',
    icon: <MailOutlined />,
    label: 'Send SMS',
    path: PATH.SEND_SMS.ROOT,
    permission: 'SEND_SMS',
  },
  {
    key: 'theme-management',
    icon: <BgColorsOutlined  />,
    label: 'Theme Management',
    path: PATH.THEME_MANAGEMENT.ROOT,
    permission: 'THEME_MANAGEMENT',
  },
  {
    key: 'config',
    icon: <SettingOutlined />,
    label: 'Configuration',
    path: PATH.CONFIG,
    permission: 'CONFIG',
  },
];

export const getFilteredMenuItems = (roleUtils) => {
  const { hasPermission } = roleUtils;

  const filterMenuItems = (items) => {
    return items
      .filter((item) => {
        if (!item.permission) return true;
        return hasPermission(item.permission);
      })
      .map((item) => {
        if (item.children) {
          return {
            ...item,
            children: filterMenuItems(item.children),
          };
        }
        return item;
      });
  };

  return filterMenuItems(MENU_CONFIG);
};
